export const shouldShowDiscount = (
  price: number,
  originalPrice?: number,
): originalPrice is number =>
  typeof originalPrice === "number" &&
  Number.isFinite(originalPrice) &&
  originalPrice > price;
